// Mapa de color/identidad visual por código de estado de pedido.
// Los códigos y su significado de negocio vienen del backend (campo `estado`);
// la etiqueta legible ya llega en el campo `valor` de cada pedido.
const ESTADOS_COLOR = {
  246: { bg: "#fff9c4", accent: "#f9a825", chip: "warning" }, // asignado / en curso
  251: { bg: "#eeeeee", accent: "#757575", chip: "default" }, // finalizado neutro
  252: { bg: "#dcedc8", accent: "#43a047", chip: "success" }, // entregado ok
  253: { bg: "#b3e5fc", accent: "#0288d1", chip: "info" }, // reclamado / revisión
  255: { bg: "#ffcdd2", accent: "#d32f2f", chip: "error" }, // rechazado
  271: { bg: "#f5f5f5", accent: "#424242", chip: "default" }, // anulado
};

const ESTADO_DEFAULT = { bg: "#ffffff", accent: "#bdbdbd", chip: "default" };

export const getColorEstado = (estado) => ESTADOS_COLOR[estado] || ESTADO_DEFAULT;

export const TABS_PEDIDOS = [
  { index: 0, key: "pendientes", label: "Pendientes" },
  { index: 1, key: "asignados", label: "Asignados" },
  { index: 2, key: "anulados", label: "Anulados" },
  { index: 3, key: "pendientesFacturacion", label: "Pendientes Facturación" },
];
